import { render, staticRenderFns } from "./DepartamentModal.vue?vue&type=template&id=b9b337a6"
import script from "./DepartamentModal.vue?vue&type=script&lang=js"
export * from "./DepartamentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports